<template lang="pug">
  list-item-card
    .columns.pl-1.pr-1(slot='header')
      .column
        .label-sm.tooltip.tooltip-bottom(:data-tooltip="'ordem_servico.numero' | tModel")
          span.text-bold {{ servico.numero }}/{{ servico.ano }}
          span  - {{ servico.assunto.descricao }}
      .column.col-auto(v-if='servico.protocolo_numero ||  servico.protocolo_ano')
        .label-sm.tooltip.tooltip-left(:data-tooltip="'ordem_servico.protocolo_tipo' | tModel")
          span {{ servico | enums('ordem_servico.protocolo_tipo') }}
          span  - {{ servico.protocolo_numero }}/{{ servico.protocolo_ano }}
    .columns
      item-col.col-3.col-sm-6.col-xs-12(label='ordem_servico.usuario', :value='servico.usuario ? servico.usuario.nome : "-"')
      item-col.col-3.col-sm-6.col-xs-12(label='ordem_servico.usuario_responsavel', :value="servico.usuario_responsavel ? servico.usuario_responsavel.nome : '-'")
      item-col.col-3.col-sm-6.col-xs-12(label='ordem_servico.created_at', :value='servico.created_at | date')
      .column.col-3.col-sm-6.col-xs-12
        small.tooltip.tooltip-left(:data-tooltip="'ordem_servico.situacao' | tModel" :class="ordemServicoSituacaoClasses[servico.situacao]") {{ servico | enums('ordem_servico.situacao') }}
        div(v-if='servico.comentario_situacao')
          .tooltip.tooltip-left(:data-tooltip="'ordem_servico.comentario_situacao' | tModel" )
            small(:class="ordemServicoComentarioSituacaoTipoClasses[servico.comentario_situacao.tipo]")
              | {{ servico.comentario_situacao.descricao || 'Neutro' }}
    div(v-if="servico.cadastro")
      .divider.text-center(:data-content="'cadastro' | tModel")
      .columns
        item-col.col-3.col-xs-12(label="cadastro.tipo" :value="servico.cadastro | enums('cadastro.tipo')")
        item-col.col-3.col-xs-12(label="cadastro.numero" :value="servico.cadastro.numero")
      .columns(v-if="servico.cadastro.contribuinte")
        item-col.col-3.col-sm-4.col-xs-12(label="contribuinte.cpf_cnpj" :value="servico.cadastro.contribuinte.cpf_cnpj | cpfCnpj")
        item-col(label="cadastro.contribuinte" :value="servico.cadastro.contribuinte.razao_social")
    div(v-if='servico.docs && servico.docs.length')
      .divider.text-center(:data-content="'ordem_servico.docs' | tModel")
      .columns
        .column.col-auto(v-for='doc in servico.docs' :key='doc.id')
          router-link.text-primary(
            :to="{name: 'fiscalizacao.docs.show', params: {id: doc.id}}"
          )
            span {{ doc.numero }}/{{ doc.ano }}

    .columns(slot='footer')
      .column
      .column.col-auto
        router-link.btn.btn-link.tooltip.tooltip-left(
          :data-tooltip="'views.buttons.show.label' | translate"
          :to="{name: 'app.osm.servicos.show', params: {id: servico.id}}"
        )
          btn-content(name='show')

</template>

<script>
import {
  ordemServicoSituacaoClasses,
  ordemServicoComentarioSituacaoTipoClasses,
} from '@/lib/constants'

export default {
  props: {
    servico: { type: Object, required: true },
  },
  computed: {
    ordemServicoSituacaoClasses() {
      return ordemServicoSituacaoClasses
    },
    ordemServicoComentarioSituacaoTipoClasses() {
      return ordemServicoComentarioSituacaoTipoClasses
    },
  },
}
</script>
